import { AloftPrice, MLSListing } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn';
import MLSDataInfoSection from './MLSDataInfoSection';
import MlsDataValueWithLabel from './MLSDataValueWithLabel';

const MLSTaxInfo = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Tax">
    <MLSDataColumn>
      {/* <MlsDataValueWithLabel value={details.tax_apn} label="APN" /> */}
      <MlsDataValueWithLabel
        value={listingData.TaxYear}
        label="Tax Year"
        options={{ noCommaInNumber: true }}
      />
    </MLSDataColumn>
    <MLSDataColumn>
      <MlsDataValueWithLabel
        value={
          listingData.TaxAnnualAmount
            ? AloftPrice.fromNumericPrice(listingData.TaxAnnualAmount ?? 0).toString(true)
            : undefined
        }
        label="Annual Tax"
      />
    </MLSDataColumn>
  </MLSDataInfoSection>
);

export default MLSTaxInfo;
